import { render, staticRenderFns } from "./TheSidebarMenu.vue?vue&type=template&id=44c74604&"
import script from "./TheSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./TheSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports